/* HoD full-fold system: PDP fold variant sync. OWNER: WP-C (29 Sep 2026). Plan §5.4 + A10, A20, A22.
   Loaded with `defer` on product fold templates only (layout/theme.liquid). Contract: work/FOLD-SYSTEM.md §6.

   The fold never runs its own variant engine and never fires variant:change.
   - Fold -> main: a fold radio change finds the main picker's matching [data-variant-input] inside the main
     #ProductSection-* and clicks it (select pickers: set .value + bubbling change). Motion's theme.Variants then
     updates everything it owns and fires variant:change. Before the theme bundle has initialised the main section,
     the fold updates itself from its own JSON straight away and the main-picker sync waits (A20.1): it replays on
     page:loaded, or as soon as theme.sections has the main instance with its variants bound (short poll).
   - Main -> fold: variant:change on document, filtered by id membership in the fold's variant JSON. The
     container's variantChange with variant === null (an unavailable combination) disables the fold button with
     "Unavailable" and keeps the last image (A20.2).
   - Prices are Liquid-rendered strings from the JSON (money_without_trailing_zeros, A10). This file never
     formats money and never types a number.
   - Image swap: only the active photo is in the HTML; a new colour's <picture> is built off-DOM, decoded, then
     crossfaded in (240ms; instant under reduced motion). Same image key = no swap. A tone change is sent to
     assets/hod-fold.js as the document event hod:fold:tone (A20.3), which keeps the scrolled-past rule. */
(function () {
  'use strict';
  var doc = document;
  var fold = doc.querySelector('[data-hod-fold][data-hod-fold-kind="product"]');
  if (!fold) return;
  var buy = fold.querySelector('[data-hod-fold-buy]');
  if (!buy) return;
  var scope = fold.parentElement || doc;

  function readJson(sel) {
    var el = scope.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var variants = readJson('script[data-hod-fold-variants]') || [];
  var images = readJson('script[data-hod-fold-images]') || {};
  if (!variants.length) return;

  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });

  var handle = buy.getAttribute('data-product-handle') || '';
  var media = fold.querySelector('[data-hod-fold-media]') || fold.querySelector('.hod-fold__media');
  var idInput = buy.querySelector('[data-hod-fold-id]');
  var atc = buy.querySelector('button[data-hod-fold-atc]');
  var atcLabel = buy.querySelector('[data-hod-fold-atc-label]');
  var priceEl = buy.querySelector('[data-hod-fold-price]');
  var live = buy.querySelector('[data-hod-fold-live]');
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  // MUST equal sizes_single in snippets/hod-fold-sources.liquid (fix round 1: a colour swap on a 3x phone would
  // otherwise pull the 1440w file). Fix round 3: 50vw (it had drifted to 67vw here while the Liquid said 60vw); a
  // single-layout fold's rendered <img> wins, so the two can no longer drift apart.
  var SIZES_SINGLE = '(max-aspect-ratio: 2/3) and (min-resolution: 2.5dppx) 45vh, (max-aspect-ratio: 2/3) 67vh, (min-aspect-ratio: 3/4) and (max-aspect-ratio: 3/2) 150vh, 100vw'; // round 4: must match snippets/hod-fold-sources.liquid
  (function () {
    var first = fold.querySelector('.hod-fold__picture:not(.hod-fold__picture--quiet) > img.hod-fold__img');
    var s = first && !fold.querySelector('.hod-fold__duo') ? first.getAttribute('sizes') : '';
    if (s) SIZES_SINGLE = s;
  })();

  var current = (idInput && byId[idInput.value]) || null;
  if (!current) {
    var checkedVals = selectedFromFold(null);
    current = findVariant(checkedVals) || variants[0];
  }
  var currentKey = fold.getAttribute('data-hod-fold-key') || (current && current.img) || '';
  var swapToken = 0;

  // ---------- helpers ----------
  function groups() { return buy.querySelectorAll('[data-hod-fold-group]'); }
  function optionIndex(name) { return parseInt(String(name).replace('option', ''), 10) - 1; }

  function selectedFromFold(base) {
    var vals = base ? base.options.slice() : [];
    Array.prototype.forEach.call(groups(), function (g) {
      var i = optionIndex(g.getAttribute('data-hod-fold-group'));
      var r = g.querySelector('input.hod-fold__radio:checked');
      if (r && i >= 0) vals[i] = r.value;
    });
    return vals;
  }

  function findVariant(vals) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < v.options.length; j++) {
        if (vals[j] !== undefined && vals[j] !== v.options[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // Best match when the exact combination does not exist: keep the option just changed, prefer available.
  function bestVariant(vals, changedIndex) {
    var exact = findVariant(vals);
    if (exact) return exact;
    var want = vals[changedIndex], pick = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[changedIndex] !== want) continue;
      if (v.available) return v;
      if (!pick) pick = v;
    }
    return pick;
  }

  function setChecked(vals) {
    Array.prototype.forEach.call(groups(), function (g) {
      var i = optionIndex(g.getAttribute('data-hod-fold-group'));
      var val = vals[i];
      Array.prototype.forEach.call(g.querySelectorAll('input.hod-fold__radio'), function (r) {
        r.checked = val !== undefined && r.value === val;
      });
      var legend = g.querySelector('[data-hod-fold-legend-value]');
      if (legend && val !== undefined) legend.textContent = val;
      // Fix round 1: a selected sold-out colour says so in the legend ("Colour — Orca Stripe · Sold out").
      var note = g.querySelector('[data-hod-fold-legend-note]');
      if (note) note.hidden = val === undefined || valueAvailable(i, val);
    });
  }

  // P18 (R1, 3 Oct 2026): the "is sold out. Choose <colour>" line shows only while the chosen variant is sold out.
  function setAlt(v) {
    Array.prototype.forEach.call(buy.querySelectorAll('[data-hod-fold-alt]'), function (el) {
      var btn = el.querySelector('[data-hod-fold-pick]');
      var g = btn && buy.querySelector('[data-hod-fold-group="' + btn.getAttribute('data-hod-fold-pick-group') + '"]');
      var i = g ? optionIndex(g.getAttribute('data-hod-fold-group')) : -1;
      var name = el.querySelector('[data-hod-fold-alt-name]');
      if (name && i >= 0 && v.options[i] !== undefined) name.textContent = v.options[i];
      el.hidden = !!v.available || (btn && i >= 0 && v.options[i] === btn.getAttribute('data-hod-fold-pick'));
    });
  }
  buy.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-hod-fold-pick]') : null;
    if (!btn) return;
    var g = buy.querySelector('[data-hod-fold-group="' + btn.getAttribute('data-hod-fold-pick-group') + '"]');
    if (!g) return;
    var want = btn.getAttribute('data-hod-fold-pick');
    Array.prototype.forEach.call(g.querySelectorAll('input.hod-fold__radio'), function (r) {
      if (r.value === want && !r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        r.focus();
      }
    });
  });

  // P27 (R1, 3 Oct 2026): each set-size pill shows "$x per towel" for the variant that has that set size and the
  // other currently selected options (colour). The strings come from the Liquid JSON ("unit"); never computed here.
  function setUnits(v) {
    if (!v || !v.options) return;
    Array.prototype.forEach.call(buy.querySelectorAll('[data-hod-fold-unit]'), function (el) {
      var idx = parseInt(el.getAttribute('data-hod-unit-index'), 10);
      var val = el.getAttribute('data-hod-unit-value');
      for (var k = 0; k < variants.length; k++) {
        var w = variants[k], ok = w.options[idx] === val;
        for (var j = 0; ok && j < w.options.length; j++) {
          if (j !== idx && w.options[j] !== v.options[j]) ok = false;
        }
        if (ok) { if (w.unit) el.textContent = w.unit + ' per towel'; return; }
      }
    });
  }

  // ---------- P20 (R2, 3 Oct 2026): The pair ----------
  // The fold's quantity pills (1 | The pair) live outside the form, like the option radios; the chosen quantity goes to
  // the hidden name="quantity" in the fold form (fold Add to bag + the P22 express button) AND to the main form's
  // quantity input, so the sticky bar, which presses the main Add to bag, adds the same. Prices come from the Liquid
  // JSON ("price2" = price x 2); this file still never formats money. window.HodFoldQty + the hod:fold:qty event tell
  // assets/hod-sticky-atc.js to show "· Pair" and the pair price.
  var qtyGroup = buy.querySelector('[data-hod-fold-qtygroup]');
  var qtyInput = buy.querySelector('[data-hod-fold-qty]');
  function foldQty() {
    if (!qtyGroup) return 1;
    var r = qtyGroup.querySelector('input[data-hod-fold-qty-radio]:checked');
    return r ? (parseInt(r.value, 10) || 1) : (qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1);
  }
  function mainQtyInput() {
    var s = mainSection();
    return s ? s.querySelector('input[name="quantity"]') : null;
  }
  function paintQty(v) {
    if (!qtyGroup) { paintBnpl(v || current, 1); return; }
    v = v || current;
    var q = foldQty();
    // Pair bundle (4 Oct 2026): Pair adds the bundle variant (its own price) when Liquid found one ("pairId"),
    // else quantity 2 of the single variant.
    var useBundle = q === 2 && v && v.pairId;
    if (idInput && v) idInput.value = useBundle ? v.pairId : v.id;
    if (qtyInput) qtyInput.value = useBundle ? '1' : String(q);
    window.HodFoldPairBundle = !!useBundle;
    if (v) {
      var p1 = qtyGroup.querySelector('[data-hod-fold-qty-price="1"]');
      var p2 = qtyGroup.querySelector('[data-hod-fold-qty-price="2"]');
      if (p1 && v.price) p1.textContent = v.price;
      if (p2 && v.price2) p2.textContent = v.price2;
      if (priceEl && v.price) priceEl.textContent = (q === 2 && v.price2) ? v.price2 : v.price;
    }
    paintBnpl(v, q);
    window.HodFoldQty = q;
    doc.dispatchEvent(new CustomEvent('hod:fold:qty', { detail: { qty: q, price: priceEl ? priceEl.textContent : '' } }));
  }
  // P21 (R2): the fold BNPL line follows the variant and The pair; amounts are Liquid strings (q1 / q2), "" = hide.
  var bnpl = buy.querySelector('[data-hod-fold-bnpl]');
  function paintBnpl(v, q) {
    if (!bnpl || !v) return;
    var amt = q === 2 ? v.q2 : v.q1;
    var a = bnpl.querySelector('[data-hod-bnpl-amt]');
    if (amt && a) a.textContent = amt;
    bnpl.hidden = !amt;
  }
  function pushQtyToMain(q) {
    var mi = mainQtyInput();
    if (!mi || String(mi.value) === String(q)) return;
    mi.value = String(q);
    mi.dispatchEvent(new Event('input', { bubbles: true }));
    mi.dispatchEvent(new Event('change', { bubbles: true }));
  }
  function qtyFromMain() {
    var mi = mainQtyInput();
    if (!mi || !qtyGroup) return;
    var n = parseInt(mi.value, 10) || 1;
    Array.prototype.forEach.call(qtyGroup.querySelectorAll('input[data-hod-fold-qty-radio]'), function (r) {
      r.checked = parseInt(r.value, 10) === n;
    });
    if (qtyInput) qtyInput.value = String(n);
    paintQty();
  }
  if (qtyGroup) {
    doc.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity' && e.target === mainQtyInput()) qtyFromMain();
    });
    doc.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.js-qty__adjust') : null;
      if (b && mainSection() && mainSection().contains(b)) window.setTimeout(qtyFromMain, 0);
    });
  }

  function valueAvailable(i, val) {
    for (var k = 0; k < variants.length; k++) {
      if (variants[k].options[i] === val && variants[k].available) return true;
    }
    return false;
  }

  function setButton(state) {
    if (!atc) return;
    var text;
    if (state === 'available') text = atc.getAttribute('data-default-text') || 'Add to bag';
    else if (state === 'unavailable') text = atc.getAttribute('data-unavailable-text') || 'Unavailable';
    else text = atc.getAttribute('data-sold-out-text') || 'Sold out';
    atc.disabled = state !== 'available';
    if (atcLabel) atcLabel.textContent = text;
  }

  function announce(text) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 30);
  }

  // ---------- state ----------
  function apply(v, fromFold) {
    if (!v) return;
    current = v;
    if (idInput) idInput.value = v.id;
    if (priceEl && v.price) priceEl.textContent = v.price;
    setChecked(v.options);
    setUnits(v);
    setAlt(v);
    setButton(v.available ? 'available' : 'sold-out');
    paintQty(v);
    swapImage(v.img);
    if (fromFold) {
      var label = v.options.join(' / ') + ', ' + v.price + (v.available ? '' : ', ' + (atc ? (atc.getAttribute('data-sold-out-text') || 'Sold out') : 'Sold out'));
      announce(label);
    }
  }

  function applyUnavailable(detail) {
    // A20.2: mirror the main picker's selection, say "Unavailable", keep the last image.
    var vals = (detail && detail.currentlySelectedValues) || null;
    if (vals && vals.length) {
      var mapped = [];
      vals.forEach(function (sv, i) {
        // Motion's shape: [{value, index:'optionN'}]
        if (sv && typeof sv === 'object') {
          var oi = sv.index ? optionIndex(sv.index) : i;
          if (oi >= 0) mapped[oi] = sv.value;
        } else {
          mapped[i] = sv;
        }
      });
      setChecked(mapped);
    } else if (detail && detail.index) {
      var g = buy.querySelector('[data-hod-fold-group="' + detail.index + '"]');
      if (g) Array.prototype.forEach.call(g.querySelectorAll('input.hod-fold__radio'), function (r) { r.checked = false; });
    }
    setButton('unavailable');
  }

  // ---------- image swap ----------
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function buildPicture(img) {
    var pic = doc.createElement('picture');
    var el = doc.createElement('img');
    if (img.layout === 'quiet') {
      pic.className = 'hod-fold__picture hod-fold__picture--quiet hod-fold__picture--incoming';
      el.className = 'hod-fold__img hod-fold__img--quiet';
      el.sizes = '(max-aspect-ratio: 3/4) 80vw, 40vw';
    } else {
      pic.className = 'hod-fold__picture hod-fold__picture--incoming';
      pic.style.setProperty('--hod-fold-focal-p', img.focal_p || '50% 45%');
      pic.style.setProperty('--hod-fold-focal-l', img.focal_l || '50% 50%');
      if (img.split && img.p) {
        var source = doc.createElement('source');
        source.media = '(max-aspect-ratio: 3/4)';
        source.srcset = img.p;
        source.sizes = SIZES_SINGLE;
        if (img.p_w) source.width = img.p_w;
        if (img.p_h) source.height = img.p_h;
        pic.appendChild(source);
      }
      el.className = 'hod-fold__img';
      el.sizes = SIZES_SINGLE;
    }
    el.srcset = img.l;
    el.src = img.l_src;
    if (img.l_w) el.width = img.l_w;
    if (img.l_h) el.height = img.l_h;
    el.alt = img.alt || '';
    el.decoding = 'async';
    el.loading = 'eager';
    pic.setAttribute('data-hod-fold-picture', '');
    pic.setAttribute('data-hod-fold-key', img.key || '');
    pic.appendChild(el);
    return { pic: pic, img: el };
  }

  function setFoldLook(img) {
    var quiet = img.layout === 'quiet';
    fold.classList.toggle('hod-fold--quiet', quiet);
    fold.classList.toggle('hod-fold--single', !quiet);
    fold.classList.toggle('hod-fold--scrim-strong', img.scrim === 'strong');
    var tone = img.tone === 'dark' ? 'dark' : 'light';
    var prevTone = fold.getAttribute('data-hod-fold-tone');
    fold.classList.remove('hod-fold--tone-light', 'hod-fold--tone-dark');
    fold.classList.add('hod-fold--tone-' + tone);
    fold.setAttribute('data-hod-fold-tone', tone);
    fold.setAttribute('data-hod-fold-key', img.key || '');
    if (img.bg) fold.style.setProperty('--hod-fold-bg', img.bg);
    if (prevTone !== tone) {
      doc.dispatchEvent(new CustomEvent('hod:fold:tone', { detail: { tone: tone } }));
    }
  }

  function swapImage(key) {
    if (!key || key === currentKey || !media) return;
    var img = images[key];
    if (!img || !img.l) return;
    currentKey = key;
    var token = ++swapToken;
    var built = buildPicture(img);
    var olds = Array.prototype.slice.call(media.querySelectorAll('.hod-fold__picture'));

    function finish() {
      if (token !== swapToken) { if (built.pic.parentNode) built.pic.parentNode.removeChild(built.pic); return; }
      setFoldLook(img);
      if (!built.pic.parentNode) media.appendChild(built.pic);
      var instant = reduce.matches;
      function cleanup() {
        if (token !== swapToken) return;
        olds.forEach(function (o) { if (o.parentNode) o.parentNode.removeChild(o); });
        if (window.HodFold && window.HodFold.update) window.HodFold.update();
      }
      if (instant) {
        built.pic.classList.add('is-in');
        cleanup();
      } else {
        // next frame so the opacity transition runs from 0
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            built.pic.classList.add('is-in');
            window.setTimeout(cleanup, 280);
          });
        });
      }
    }
    // In the DOM (at opacity 0 via .hod-fold__picture--incoming) so the browser picks the <source> for this
    // viewport; decode() then waits for that file.
    media.appendChild(built.pic);
    var ready = built.img.decode ? built.img.decode() : Promise.resolve();
    ready.then(finish, finish);
  }

  // ---------- main picker ----------
  function mainSection() {
    var sections = doc.querySelectorAll('.product-section[data-section-type="product"]');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (s.getAttribute('data-modal') === 'true') continue;
      if (!handle || s.getAttribute('data-product-handle') === handle) return s;
    }
    return null;
  }

  function mainReady(section) {
    if (!section) return false;
    var t = window.theme;
    if (!t || !t.Variants || !t.sections || typeof t.sections._findInstance !== 'function') return false;
    var inst = t.sections._findInstance(section.getAttribute('data-section-id'));
    return !!(inst && inst.variants);
  }

  function cssEsc(v) {
    if (window.CSS && CSS.escape) return CSS.escape(v);
    return String(v).replace(/["\\]/g, '\\$&');
  }

  var pending = null;
  function pushToMain(vals) {
    var section = mainSection();
    if (!section) return;
    if (!mainReady(section)) { pending = vals; waitForMain(); return; }
    pending = null;
    for (var i = 0; i < vals.length; i++) {
      if (vals[i] === undefined) continue;
      var idx = 'option' + (i + 1);
      var input = section.querySelector('input[data-variant-input][data-index="' + idx + '"][value="' + cssEsc(vals[i]) + '"]');
      if (input) {
        if (!input.checked) input.click();
        continue;
      }
      var select = section.querySelector('select[data-variant-input][data-index="' + idx + '"]');
      if (select && select.value !== vals[i]) {
        select.value = vals[i];
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  var polling = false;
  function waitForMain() {
    if (polling) return;
    polling = true;
    var tries = 0;
    (function tick() {
      if (!pending) { polling = false; return; }
      if (mainReady(mainSection())) { polling = false; pushToMain(pending); return; }
      if (++tries > 120) { polling = false; return; } // ~30 s; page:loaded still replays after that
      window.setTimeout(tick, 250);
    })();
  }
  doc.addEventListener('page:loaded', function () { if (pending) pushToMain(pending); });

  // ---------- events ----------
  buy.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.classList || !r.classList.contains('hod-fold__radio')) return;
    if (r.hasAttribute('data-hod-fold-qty-radio')) {
      var q = foldQty();
      paintQty();
      pushQtyToMain(window.HodFoldPairBundle ? 1 : q);
      announce((q === 2 ? 'Pair, ' : 'Single, ') + (priceEl ? priceEl.textContent : ''));
      return;
    }
    var changed = optionIndex(r.getAttribute('data-hod-fold-option'));
    var vals = selectedFromFold(current);
    var v = bestVariant(vals, changed);
    if (v) apply(v, true);
    pushToMain(v ? v.options : vals);
  });

  doc.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v) return; // null variants are handled from the main container below (id filter can't apply)
    var mine = byId[String(v.id)];
    if (mine) apply(mine, false);
  });

  function bindContainer() {
    var section = mainSection();
    if (!section || section.__hodFoldBound) return;
    section.__hodFoldBound = true;
    section.addEventListener('variantChange', function (e) {
      if (e && e.detail && e.detail.variant === null) applyUnavailable(e.detail);
    });
  }
  bindContainer();
  doc.addEventListener('shopify:section:load', bindContainer);

  // Scroll restoration / ?variant= already honoured server-side; make sure the controls agree with the id.
  setChecked(current.options);
  // P20: ?hod_qty=2 (the gifting hub's pair tile) preselects The pair.
  if (qtyGroup && /[?&]hod_qty=2(&|$)/.test(window.location.search)) {
    var pairRadio = qtyGroup.querySelector('input[data-hod-fold-qty-radio][value="2"]');
    if (pairRadio) { pairRadio.checked = true; paintQty(); pushQtyToMain(window.HodFoldPairBundle ? 1 : 2); }
  }
  paintQty();
})();
